import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { PageContainer } from '~/@mid_ui/page-container/PageContainer'
import { useAmbassadorData } from '~/@biz_ambassador/ambassador/useAmbassadorData'
import { CreateAmbassadorDialog } from './components/CreateAmbassadorDialog'
import { ReportChangeDialog } from './components/ReportChangeDialog'
import { Dashboard } from './components/Dashboard'

function AmbassadorPage() {
  const navigate = useNavigate()
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false)
  const [isReportDialogOpen, setIsReportDialogOpen] = useState(false)

  const { query, createMutation, reportChangeMutation } = useAmbassadorData()

  return (
    <PageContainer className="flex flex-col shrink gap-10 w-full pt-10 pb-15 md:pl-40 md:pr-15">
      <Dashboard
        data={query.data}
        isLoading={query.isLoading}
        setIsReportDialogOpen={setIsReportDialogOpen}
        setIsCreateDialogOpen={setIsCreateDialogOpen}
        onSelectAmbassador={(item) =>
          navigate(`/settings/ambassador/${item.id}`)
        }
      />

      <CreateAmbassadorDialog
        open={isCreateDialogOpen}
        onOpenChange={setIsCreateDialogOpen}
        onCreate={(data) => createMutation.mutateAsync(data)}
      />

      <ReportChangeDialog
        open={isReportDialogOpen}
        onOpenChange={setIsReportDialogOpen}
        onSubmit={(message) => reportChangeMutation.mutateAsync(message)}
      />
    </PageContainer>
  )
}

export default AmbassadorPage
